import { inject } from '@angular/core';
import { AuthService } from '@coin/shared/auth/data-access';

export const canActivateDeputyGuard = async (): Promise<boolean> =>
  !(await inject(AuthService).getEmulationDecoded())?.IsDeputy;
